export const FETCH_MENU_CURATION_TASK = {
  START: 'START_FETCH_MENU_CURATION_TASK',
  COMPLETE: 'COMPLETE_FETCH_MENU_CURATION_TASK',
  FAIL: 'FAIL_FETCH_MENU_CURATION_TASK',
  CLEANUP: 'CLEANUP_FETCH_MENU_CURATION_TASK',
}

export const REFRESH_MENU_CURATION_TASK = {
  START: 'START_REFRESH_MENU_CURATION_TASK',
  COMPLETE: 'COMPLETE_REFRESH_MENU_CURATION_TASK',
  FAIL: 'FAIL_REFRESH_MENU_CURATION_TASK',
}

export const UPDATE_MENU_CURATION_TASK = {
  START: 'START_UPDATE_MENU_CURATION_TASK',
  COMPLETE: 'COMPLETE_UPDATE_MENU_CURATION_TASK',
  FAIL: 'FAIL_UPDATE_MENU_CURATION_TASK',
}

export const REOPEN_MENU_CURATION_TASK = {
  START: 'START_REOPEN_MENU_CURATION_TASK',
  COMPLETE: 'COMPLETE_REOPEN_MENU_CURATION_TASK',
  FAIL: 'FAIL_REOPEN_MENU_CURATION_TASK',
}

export const UNLOCK_MENU_CURATION_TASK_DISHES = {
  START: 'START_UNLOCK_MENU_CURATION_TASK_DISHES',
  COMPLETE: 'COMPLETE_UNLOCK_MENU_CURATION_TASK_DISHES',
  FAIL: 'FAIL_UNLOCK_MENU_CURATION_TASK_DISHES',
}

export const RETRY_MENU_CURATION_TASK_AUTOMATIC_CURATION = {
  START: 'START_RETRY_MENU_CURATION_TASK_AUTOMATIC_CURATION',
  COMPLETE: 'COMPLETE_RETRY_MENU_CURATION_TASK_AUTOMATIC_CURATION',
  FAIL: 'FAIL_RETRY_MENU_CURATION_TASK_AUTOMATIC_CURATION',
}

export const RETRY_MENU_CURATION_TASK_LABELS_AND_INGREDIENTS = {
  START: 'START_RETRY_MENU_CURATION_TASK_LABELS_AND_INGREDIENTS',
  COMPLETE: 'COMPLETE_RETRY_MENU_CURATION_TASK_LABELS_AND_INGREDIENTS',
  FAIL: 'FAIL_RETRY_MENU_CURATION_TASK_LABELS_AND_INGREDIENTS',
}

export const UPDATE_MENU_CURATION_TASK_STATUS_FLAG = {
  START: 'START_UPDATE_MENU_CURATION_TASK_STATUS_FLAG',
  COMPLETE: 'COMPLETE_UPDATE_MENU_CURATION_TASK_STATUS_FLAG',
  FAIL: 'FAIL_UPDATE_MENU_CURATION_TASK_STATUS_FLAG',
}

export const REFRESH_MENU_CURATION_TASK_COUNTS = {
  START: 'START_REFRESH_MENU_CURATION_TASK_COUNTS',
  COMPLETE: 'COMPLETE_REFRESH_MENU_CURATION_TASK_COUNTS',
  FAIL: 'FAIL_REFRESH_MENU_CURATION_TASK_COUNTS',
}

export const FETCH_LOCATION_NAMES = {
  START: 'START_FETCH_LOCATION_NAMES',
  COMPLETE: 'COMPLETE_FETCH_LOCATION_NAMES',
  FAIL: 'FAIL_FETCH_LOCATION_NAMES',
}

export const DUPLICATE_MENU_CURATION_TASK = {
  START: 'START_DUPLICATE_MENU_CURATION_TASK',
  COMPLETE: 'COMPLETE_DUPLICATE_MENU_CURATION_TASK',
  FAIL: 'FAIL_DUPLICATE_MENU_CURATION_TASK',
}

export const FETCH_MENU_CURATION_TASK_HISTORY = {
  START: 'START_FETCH_MENU_CURATION_TASK_HISTORY',
  COMPLETE: 'COMPLETE_FETCH_MENU_CURATION_TASK_HISTORY',
  FAIL: 'FAIL_FETCH_MENU_CURATION_TASK_HISTORY',
}

export const REQUEST_MENU_CURATION_TASK_SCRAPING_REVIEW = {
  START: 'START_REQUEST_MENU_CURATION_TASK_SCRAPING_REVIEW',
  COMPLETE: 'COMPLETE_REQUEST_MENU_CURATION_TASK_SCRAPING_REVIEW',
  FAIL: 'FAIL_REQUEST_MENU_CURATION_TASK_SCRAPING_REVIEW',
}

export const UPDATE_MENU_CURATION_TASK_SCRAPING_REVIEW_STATUS = {
  START: 'START_UPDATE_MENU_CURATION_TASK_SCRAPING_REVIEW_STATUS',
  COMPLETE: 'COMPLETE_UPDATE_MENU_CURATION_TASK_SCRAPING_REVIEW_STATUS',
  FAIL: 'FAIL_UPDATE_MENU_CURATION_TASK_SCRAPING_REVIEW_STATUS',
}

export const DOWNLOAD_MENU_DOCUMENT = {
  START: 'START_DOWNLOAD_MENU_DOCUMENT',
  COMPLETE: 'COMPLETE_DOWNLOAD_MENU_DOCUMENT',
  FAIL: 'FAIL_DOWNLOAD_MENU_DOCUMENT',
}

export const FETCH_SCRAPING_REVIEW_COMMENTS = {
  START: 'START_FETCH_SCRAPING_REVIEW_COMMENTS',
  COMPLETE: 'COMPLETE_FETCH_SCRAPING_REVIEW_COMMENTS',
  FAIL: 'FAIL_FETCH_SCRAPING_REVIEW_COMMENTS',
}
